import {QuestionModel} from "./question";

class SurveyQuestionModel extends QuestionModel {
}

export {
    SurveyQuestionModel
}